<template>
  <Widget>
    <v-card class="pa-8" style="border-radius: 6px; height: 150px" flat>
      <v-row justify="start" no-gutters>
        <v-col>
          <h2 class="text-left mt-3">Select questionnaire</h2>
        </v-col>
      </v-row>
      <v-row justify="start">
        <v-col cols="12">
          <v-select
            :items="questionnairesStore.sentQuestionnaires"
            item-title="label"
            item-value="id"
            density="compact"
            return-object
            variant="outlined"
            single-line
            @update:model-value="
              async (questionnaire) => updateView(questionnaire)
            "
            v-model="selectedQuestionnaire"
            v-if="questionnairesStore.sentQuestionnaires.length > 0"
            :disabled="questionnairesStore.sentQuestionnaires.length == 1"
          />
        </v-col>
      </v-row>
    </v-card>
  </Widget>
</template>

<script setup lang="ts">
import Widget from "@/views/dashboard-view/Widget.vue";
import { useQuestionnairesStore } from "@/stores/questionnaires";

import { Questionnaire } from "@/models/questionnaire";
import { useStatsStore } from "@/stores/statsStore";
import { useSnackBarStore } from "@/stores/snackBarStore";
import { ref, onMounted } from "vue";

const emit = defineEmits<{
  (e: "updated-selected-questionnaires", questionnaire: Questionnaire): void;
}>();

const questionnairesStore = useQuestionnairesStore();
const statsStore = useStatsStore();
const snackBareStore = useSnackBarStore();

const selectedQuestionnaire = ref(new Questionnaire());

onMounted(() => {
  if (questionnairesStore.selectedQuestionnaire.id) {
    selectedQuestionnaire.value = questionnairesStore.selectedQuestionnaire;
  } else {
    selectedQuestionnaire.value = questionnairesStore.latestSentQuestionnaire ?? new Questionnaire();
  }
})


async function updateView(questionnaire: Questionnaire) {
  try {
    selectedQuestionnaire.value = questionnaire;
    questionnairesStore.selectedQuestionnaire = questionnaire;
    await statsStore.setStatsSummary(selectedQuestionnaire.value.id);
  } catch (error) {
    snackBareStore.showError();
  }
}
</script>
